import {
  authStorageInitialState,
  useGetUserQuery,
  User,
  UsersPermissionsUser
} from "@mc-intranet/shared";
import { useSetAtom } from "jotai";
import { Navigate, useLocation } from "react-router-dom";

import { authStorageAtom } from "../../atoms";
import { useGraphQLClient } from "../../cache";

type Props = {
  user?: User;
  restricted?: boolean;
  children: JSX.Element;
};

const PrivateRoute = (props: Props) => {
  const { children, user, restricted = false } = props;

  const location = useLocation();
  const setAuthStorage = useSetAtom(authStorageAtom);
  const { client } = useGraphQLClient();

  useGetUserQuery(
    client,
    { userId: user?.documentId as string },
    {
      enabled: !!user,
      onSuccess: (data) => {
        setAuthStorage((prev) => {
          return {
            ...prev,
            user: data.usersPermissionsUser as UsersPermissionsUser
          };
        });
      },
      onError: (error: any) => {
        setAuthStorage(authStorageInitialState);
      }
    }
  );

  if (!user || restricted) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
